import { I18nComponente } from "@/types/gerais"

export const ACarregamentoCalendarioi18n: I18nComponente = {
  "pt-BR": {
   suasAtividadesEstaoSendoCarregadas: "Suas atividades estão sendo carregadas"
  },
  "es-CO": {
    suasAtividadesEstaoSendoCarregadas: "Tus actividades se están cargando"
  }
}
